export default __webpack_public_path__ + "static/media/mamut_m2.6759eca3.png";